<form class="details-form form" [formGroup]="contactDetailsForm()">
  <mat-form-field appearance="outline">
    <mat-label>Your email address</mat-label>
    <input matInput placeholder="Your email address" formControlName="email" />
    @if (contactDetailsForm().get('email')?.invalid) {
    <mat-error>Email is invalid</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Your cellphone number</mat-label>
    <input
      matInput
      placeholder="Your cellphone number"
      formControlName="mobileNr"
      type="text"
      pattern="[0-9]*"
      inputmode="numeric"
      maxlength="10"
      required
    />

    @if (contactDetailsForm().get('mobileNr')?.invalid) {
    <mat-error>Cellphone number is invalid</mat-error>
    }
  </mat-form-field>

  <div class="w-full otp-container">
    <mat-form-field class="otp" appearance="outline">
      <mat-label>Enter your OTP</mat-label>
      <input
        placeholder="Enter your OTP"
        matInput
        class="otp-digit"
        type="text"
        pattern="[0-9]*"
        inputmode="numeric"
        maxlength="4"
        formControlName="otp"
      />
      @if (contactDetailsForm().get('otp')?.hasError('invalidOtp')) {
      <mat-error>The OTP you have entered is incorrect</mat-error>
      } @else if(contactDetailsForm().get('otpRequested')?.value) {
      <mat-hint>Please enter the OTP that has been sent to your cellphone number</mat-hint>
      } @else {
      <mat-hint>Add your cellphone number and then tap “Get OTP” to receive an SMS</mat-hint>
      }
    </mat-form-field>

    <button
      type="button"
      class="get-otp-button"
      matButton="outlined"
      [ngClass]="{
        'disabled': contactDetailsForm().get('mobileNr')?.invalid || isCooldownActive() || store.requestingOTP(),
      
      }"
      [disabled]="
        contactDetailsForm().get('mobileNr')?.invalid || isCooldownActive() || store.requestingOTP()
      "
      (click)="onGetOtp()"
    >
      @if (!isCooldownActive() && !store.requestingOTP()) {
      <span class="text">Get OTP</span>
      } @else if (store.requestingOTP()) {
      <mat-progress-spinner class="spinner" diameter="20" mode="indeterminate">
      </mat-progress-spinner>
      } @else if (isCooldownActive()) {
      <span class="text">Retry ({{ cooldownRemaining() }}s)</span>
      }
    </button>
  </div>
</form>
